// Copyright (c) Docugami, Inc. All rights reserved.
import React from 'react';
import { IButtonStyles, CommandBarButton, IOverflowSetItemProps, OverflowSet, Text } from "@fluentui/react";
import { ChunkInstance } from '../../../networking/api';

export function scrollIntoViewIfNeeded(target: Element, parent: Element, options?: ScrollIntoViewOptions) {
    if (target.getBoundingClientRect().bottom > parent.getBoundingClientRect().bottom ||
            target.getBoundingClientRect().top < parent.getBoundingClientRect().top) {
        target.scrollIntoView({ behavior: "smooth", ...options });
    }
}

export function onRenderOverflowButton(overflowItems: any[] | undefined): JSX.Element {
    const buttonStyles: Partial<IButtonStyles> = {
        root: {
            backgroundColor: 'white',
            minWidth: 0,
            padding: '0 4px',
            alignSelf: 'stretch',
            height: 'auto'
        }
    };

    // @ts-ignore
    return <CommandBarButton styles={buttonStyles} menuIconProps={{ iconName: 'More' }} menuProps={{ items: overflowItems }} />;
}

export function onRenderOverflowButtonItem(item: IOverflowSetItemProps): JSX.Element | null {
    if (item.onRender) {
        return item.onRender(item);
    }

    if (item.hidden) {
        return null;
    }

    return <CommandBarButton onClick={item.onClick} iconProps={{ iconName: item.icon }} menuProps={item.subMenuProps} text={item.name} />
}

export function getSubHeadingTabStrip(
    subHeadings: string[],
    activeSubHeading: number,
    setActiveSubHeading: React.Dispatch<React.SetStateAction<number>>): JSX.Element {
    var tabs: JSX.Element[] = [];

    for (let i=0; i<subHeadings.length; i++) {
        tabs.push(
            <div
                onClick = { () => setActiveSubHeading(i) }
                className={activeSubHeading === i ? "taskpaneSubHeaderTabCurrent" : "taskpaneSubHeaderTabNotCurrent"}>
                <Text variant="tiny" className="taskpaneSubHeaderTabText">{subHeadings[i]}</Text>
            </div>)
    }

    return (
        <div className="taskpaneSubHeaderTabstripContainer">
            <div className="taskpaneSubHeaderTabstrip">
                {tabs}
            </div>
        </div>
    )
}

export function showFullText(
    text: string,
    setModalBody: React.Dispatch<React.SetStateAction<string>>,
    setModalShowing: React.Dispatch<React.SetStateAction<boolean>>): void {
    setModalBody(text);
    setModalShowing(true);
}

export function modalDismissed(
    setModalBody: React.Dispatch<React.SetStateAction<string>>,
    setModalShowing: React.Dispatch<React.SetStateAction<boolean>>): void {
    setModalShowing(false);
    setModalBody('');
}

interface showAllInstanceOption {
    label: string;
    viewAllVariations: (label: string) => void;
}

export function getOverflowMenu(
    text: string,
    setModalBody: React.Dispatch<React.SetStateAction<string>>,
    setModalShowing: React.Dispatch<React.SetStateAction<boolean>>,
    viewAllVariationsOption: showAllInstanceOption | null)
    : JSX.Element {
    var overflowItems = [
        {
            key: "view_all",
            name: "View Full Text",
            onClick: () => showFullText(text, setModalBody, setModalShowing)
        }
    ];

    if (viewAllVariationsOption !== null) {
        overflowItems.push({
            key: "view_instances",
            name: "View All Variations",
            onClick: () => viewAllVariationsOption.viewAllVariations(viewAllVariationsOption.label)
        })
    }

    return <div><OverflowSet styles={{ overflowButton: { marginLeft: "auto" } }} className="overflowSetButton"
        overflowItems={overflowItems} onRenderItem={onRenderOverflowButtonItem} onRenderOverflowButton={onRenderOverflowButton}></OverflowSet>
    </div>
}

export function formatClauseNameForUx(name: string) {
    if (!name) {
        name = "unnamed"
    }
    var trimmed = name.replace(/^[."“”':_\-\s]*|[."“”':_\-\s]*$/g, '');
    var spaced = trimmed.replace(/[_-]/g, ' ');
    var titlecased = spaced.replace(/\w\S*/g,  w => w.charAt(0).toUpperCase() + w.substr(1).toLowerCase());

    return titlecased;
}

export function getContextualChunkInstances(
    selectedChunkInstance: ChunkInstance,
    instancesWithInfo: ChunkInstance[]): ChunkInstance[]
{
    var res: ChunkInstance[] = [];

    if (!selectedChunkInstance) {
        return res;
    }

    if (selectedChunkInstance.hasAssistedAuthoringInfo) {
        res.push(selectedChunkInstance);
    }

    /*var instances = [...instancesWithInfo];
    instances.sort((a, b) => {
        if (a.tokenRange.fromTok < b.tokenRange.fromTok) {
            return -1;
        }

        if (a.tokenRange.fromTok === b.tokenRange.fromTok) {
            if (a.tokenRange.toTok < b.tokenRange.toTok) {
                return -1;
            }

            if (a.tokenRange.toTok === b.tokenRange.toTok) {
                return 0;
            }
        }

        return 1;
    })

    var idx = instances.findIndex(x => x.chunkInstanceId === selectedChunkInstance.chunkInstanceId);
    var contextLen = 3;

    // add all children
    var j = idx + 1;
    while (j < instances.length) {
        if (instances[j].tokenRange.fromTok >= selectedChunkInstance.tokenRange.toTok) {
            break;
        }

        if (!instances[j].hasAssistedAuthoringInfo) {
            j++;
            continue;
        }

        res.push(instances[j]);
        j++;
    }

    var N = 3;
    var nonAncestorsAdded = 0;

    // add previous N all ancestors
    for (let i=idx-1; i>=0; i--) {
        if (!instances[i].hasAssistedAuthoringInfo) {
            continue;
        }

        if (instances[i].tokenRange.toTok >= selectedChunkInstance.tokenRange.toTok) {
            res.push(instances[i]);
        } else if (nonAncestorsAdded < N) {
            res.push(instances[i]);
            nonAncestorsAdded++;
        }
    }

    // add next N after children
    var numAdded = 0;
    for (let i=j; i<instances.length; i++) {
        if (!instances[i].hasAssistedAuthoringInfo) {
            continue;
        }

        res.push(instances[i]);
        numAdded++;

        if (numAdded === N) {
            break;
        }
    }*/

    return res;
}

export function normalizeFragmentText(text: string): string
{
    return text.replace(/^[."“”':_\-\s]*/g, ' ');
}
